import React, { Component, PropTypes } from 'react';
import Modal from 'common/components/Modal';
import shallowCompare from 'react-addons-shallow-compare';
import cx from 'classnames';
import { Dropdown, Form } from 'semantic-ui-react';

class CopyZone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      caseId: undefined,
      zoneId: undefined,
      zoneTemplateId: undefined,
      canSubmit: false,
      fromTemplate: false,
    };

    this._caseChanged = this._caseChanged.bind(this);
    this._zoneChanged = this._zoneChanged.bind(this);
    this._zoneTemplateChanged = this._zoneTemplateChanged.bind(this);
    this._submit = this._submit.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  _caseChanged(evt, { value }) {
    this.setState({
      caseId: value,
      zoneId: undefined,
      canSubmit: false,
    });
  }

  _zoneChanged(evt, { value }) {
    this.setState({
      zoneId: value,
      zoneTemplateId: undefined,
      canSubmit: true,
    });
  }

  _zoneTemplateChanged(evt, { value }) {
    this.setState({
      zoneTemplateId: value,
      zoneId: undefined,
      caseId: undefined,
      canSubmit: true,
    });
  }

  _submit(evt) {
    evt.preventDefault();
    const { zoneId, zoneTemplateId, fromTemplate } = this.state;
    if (zoneId || zoneTemplateId) {
      this.props.onSubmit(zoneId, zoneTemplateId, fromTemplate);
    }
  }

  render() {
    const { onClose, zonesRef, zoneTemplatesRef } = this.props;
    const { fromTemplate, canSubmit, isLoading } = this.state;

    const buttonClass = cx('ui primary button', {
      disabled: !canSubmit,
      loading: isLoading,
    });

    const caseOptions = zonesRef.map(z => ({
      key: z.case_id,
      text: z.case_label,
      value: z.case_id,
    }));

    let zoneOptions = [];
    let zoneTemplateOptions = zoneTemplatesRef.map(z => ({
      key: z.id,
      text: `${z.name}`,
      value: z.id,
    }));

    if (this.state.caseId) {
      zoneOptions = zonesRef
        .filter(z => z.case_id === this.state.caseId)
        .map(z => ({
          key: z.zone_id,
          text: `${z.zone_label} - ${z.task_type_label}`,
          value: z.zone_id,
        }));
    }

    const onCheckedChange = (evt, change) => {
      let value = undefined;
      if (change.value === 'true') {
        value = true;
      } else if (change.value === 'false') {
        value = false;
      }

      this.setState({ fromTemplate: value, canSubmit: false });
    };

    return (
      <Modal isOpened closable onClose={onClose}>
        <div className="header">Récupérer un lieu</div>
        <div className="content">
          <Form.Field>
            <Form.Group inline style={{ marginBottom: '5px' }}>
              <Form.Radio
                label="D'un chantier existant"
                name="fromTemplate"
                value="false"
                checked={fromTemplate === false}
                onChange={onCheckedChange}
                width={2}
              />
              <Form.Radio
                label="Mise à disposition par mon manager"
                name="fromTemplate"
                value="true"
                checked={fromTemplate === true}
                onChange={onCheckedChange}
                width={2}
              />
            </Form.Group>
          </Form.Field>
          {fromTemplate && (
            <form id="zoneForm" className="ui form" onSubmit={this._submit}>
              <Form.Field>
                <label>Zone</label>
                <Dropdown
                  onChange={this._zoneTemplateChanged}
                  fluid
                  selection
                  placeholder="Choisir une zone"
                  options={zoneTemplateOptions}
                />
              </Form.Field>
            </form>
          )}
          {!fromTemplate && (
            <form id="zoneForm" className="ui form" onSubmit={this._submit}>
              <Form.Field>
                <label>Chantier</label>
                <Dropdown
                  onChange={this._caseChanged}
                  fluid
                  selection
                  placeholder="Choisir un chantier"
                  options={caseOptions}
                />
              </Form.Field>
              <Form.Field>
                <label>Zone</label>
                <Dropdown
                  onChange={this._zoneChanged}
                  fluid
                  selection
                  placeholder="Choisir une zone"
                  options={zoneOptions}
                />
              </Form.Field>
            </form>
          )}
        </div>
        <div className="actions">
          <button type="submit" form="zoneForm" className={buttonClass}>
            Enregister
          </button>
        </div>
      </Modal>
    );
  }
}

CopyZone.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  zonesRef: PropTypes.array.isRequired,
};

export default CopyZone;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/CopyZone.js